import { jsx as t, jsxs as c, Fragment as H } from "react/jsx-runtime";
import { createElement as Y, createContext as ee, useContext as te, useState as F, useEffect as se } from "react";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as a } from "zod";
import { withZod as p } from "@made-people/react-prop-guard";
import { checkoutDisclaimerBlueprint as ae, checkoutBlueprint as re, addressSummaryBlueprint as ne, addressFormBlueprint as oe, checkoutPaymentWrapperStyling as le, shippingMethodOptionStyling as ie, shippingMethodsStyling as ce } from "./index-blueprint.es.js";
import { componentWrapperSchema as de, ComponentWrapper as ue } from "@made-people/blueprint-component-wrapper";
import { headingSchema as T, Heading as w } from "@made-people/blueprint-heading";
import { Markdown as me } from "@made-people/blueprint-markdown";
import { linkAsLinkSchema as pe, LinkAsLink as he } from "@made-people/blueprint-link";
import { useTranslate as h } from "@made-people/grease-translations";
import { checkoutAddressFormPropsSchema as ge } from "@made-people/grease-checkout";
import { buttonAsButtonSchema as M, Button as E } from "@made-people/blueprint-button";
import { InputField as _, inputFieldSharedSchema as be, SelectBox as Ce, SelectBoxItem as ve, Checkbox as z } from "@made-people/blueprint-form";
import { useNewsletterMethod as Ne } from "@made-people/grease-newsletter";
import { CountrySelectorUpdateOnChange as ye } from "@made-people/blueprint-site-settings";
import { ResponsiveImage as fe } from "@made-people/blueprint-responsive-image";
import { CheckIcon as Se } from "@made-people/blueprint-icons";
import { shippingBarometerSchema as ke } from "@made-people/blueprint-shipping-barometer";
import "@made-people/blueprint";
const Ae = a.object({
  variants: a.custom().optional(),
  text: a.string().optional()
}), xe = m(
  "CheckoutDisclaimer",
  p(
    {
      schema: Ae,
      defaultProps: {}
    },
    ({ variants: e, text: s }) => {
      const r = ae.styles(e);
      return !s || s === "<p> </p>" ? null : /* @__PURE__ */ t("section", { className: r.wrapper, children: /* @__PURE__ */ t(me, { content: s }) });
    }
  )
), _e = a.object({
  layout: de.shape.layout.optional(),
  variants: a.custom().optional(),
  children: a.custom().optional(),
  heading: T.optional(),
  disclaimers: a.object({ text: a.string().optional() }).array().optional(),
  backLink: pe.optional(),
  cartIsEmpty: a.boolean().optional()
}), ot = m(
  "Checkout",
  p(
    {
      schema: _e,
      defaultProps: {
        layout: {
          spacing: {
            y: "none"
          }
        }
      }
    },
    ({
      layout: e,
      heading: s,
      backLink: r,
      disclaimers: o,
      cartIsEmpty: l,
      variants: u,
      children: f
    }) => {
      const n = re.main.styles(u), v = h();
      return /* @__PURE__ */ c(
        ue,
        {
          className: n.wrapper,
          background: n.background,
          layout: { ...e },
          children: [
            r && /* @__PURE__ */ t(he, { ...r, className: n.backLink }),
            (s == null ? void 0 : s.heading) && /* @__PURE__ */ t(w, { ...s, className: n.heading }),
            o && o.length > 0 && o.map((d, N) => /* @__PURE__ */ Y(xe, { ...d, key: N })),
            l && /* @__PURE__ */ t("p", { className: n.emptyCart, children: v("Checkout_EmptyCart") }),
            f
          ]
        }
      );
    }
  )
), $ = ee(null), B = ({
  children: e,
  setAddressField: s,
  getHelperText: r
}) => /* @__PURE__ */ t($.Provider, { value: { setAddressField: s, getHelperText: r }, children: e }), A = () => {
  const e = te($);
  if (!e)
    throw new Error("useFormContext must be used within a FormProvider");
  return e;
}, Fe = a.object({
  firstName: a.object({ value: a.string(), required: a.boolean() })
}), W = m(
  "CheckoutAddressFormFirstName",
  p(Fe, ({ firstName: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_FirstName"),
        value: e.value,
        required: e.required,
        onChange: (l) => s("firstName", l),
        template: "floating-label",
        helperText: r("firstName"),
        name: "fname"
      }
    );
  })
), Te = a.object({
  lastName: a.object({ value: a.string(), required: a.boolean() })
}), I = m(
  "CheckoutAddressFormLastName",
  p(Te, ({ lastName: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_LastName"),
        value: e.value,
        required: e.required,
        onChange: (l) => s("lastName", l),
        template: "floating-label",
        helperText: r("lastName"),
        name: "lname"
      }
    );
  })
), we = a.object({
  email: a.object({ value: a.string(), required: a.boolean() })
}), R = m(
  "CheckoutAdressFormEmail",
  p(we, ({ email: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_Email"),
        value: e.value,
        required: e.required,
        onChange: (l) => s("email", l),
        template: "floating-label",
        helperText: r("email"),
        name: "email"
      }
    );
  })
), G = a.object({
  street: a.object({ value: a.string(), required: a.boolean() }),
  maxLength: be.shape.maxLength.optional()
}), D = m(
  "CheckoutAddressFormStreet",
  p(G, ({ street: e, maxLength: s }) => {
    const { setAddressField: r, getHelperText: o } = A(), l = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: l("Checkout_Adress_Label_Street"),
        value: e.value,
        required: e.required,
        onChange: (u) => r("street", u),
        template: "floating-label",
        helperText: o("street"),
        name: "address",
        maxLength: s
      }
    );
  })
), je = a.object({
  zipCode: a.object({ value: a.string(), required: a.boolean() })
}), Z = m(
  "CheckoutAddressFormZipCode",
  p(je, ({ zipCode: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_Zip"),
        id: "zipCode",
        value: e.value,
        required: e.required,
        onChange: (l) => s("zipCode", l),
        template: "floating-label",
        helperText: r("zipCode"),
        name: "zip"
      }
    );
  })
), qe = a.object({
  phoneNumber: a.object({ value: a.string(), required: a.boolean() })
}), O = m(
  "CheckoutAddressFormPhoneNumber",
  p(qe, ({ phoneNumber: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_PhoneNumber"),
        type: "tel",
        value: e.value,
        required: e.required,
        onChange: (l) => s("phoneNumber", l),
        template: "floating-label",
        helperText: r("phoneNumber"),
        name: "mobile"
      }
    );
  })
), Le = a.object({
  city: a.object({ value: a.string(), required: a.boolean() })
}), V = m(
  "CheckoutAddressFormCity",
  p(Le, ({ city: e }) => {
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    return /* @__PURE__ */ t(
      _,
      {
        placeholder: o("Checkout_Adress_Label_City"),
        value: e.value,
        required: e.required,
        onChange: (l) => s("city", l),
        template: "floating-label",
        helperText: r("city"),
        name: "city"
      }
    );
  })
), Pe = a.object({
  country: a.custom()
}), U = m(
  "CheckoutAddressFormState",
  p(Pe, ({ country: e }) => {
    var u, f;
    const { setAddressField: s, getHelperText: r } = A(), o = h();
    if (!e.selectedCountry.stateRequired)
      return null;
    const l = r("state");
    return /* @__PURE__ */ c("div", { style: { width: "100%" }, children: [
      /* @__PURE__ */ t(
        Ce,
        {
          value: (u = e.selectedCountry.selectedState) == null ? void 0 : u.value,
          label: o("Checkout_Adress_Label_State"),
          onChange: (n) => s("state", n),
          children: (f = e.selectedCountry.states) == null ? void 0 : f.map((n, v) => /* @__PURE__ */ t(
            ve,
            {
              value: n.value,
              label: n.label
            },
            v
          ))
        }
      ),
      l && /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-gray-600 data-[is-type='error']:text-system-error data-[is-type='warning']:text-system-warning data-[is-type='info']:text-system-info", children: l.text })
    ] });
  })
), He = ({ className: e }) => {
  const s = h();
  return /* @__PURE__ */ t("p", { className: e, children: s("Checkout_TermsAndConditions") });
}, Me = m(
  "CheckoutAddressSummary",
  ({ address: e }) => {
    if (!e)
      return;
    const s = ne.styles(), r = h();
    return /* @__PURE__ */ c("div", { className: s.wrapper, children: [
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Name") }),
        /* @__PURE__ */ c("span", { className: s.value, children: [
          e.firstName.value,
          " ",
          e.lastName.value
        ] })
      ] }),
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Email") }),
        /* @__PURE__ */ t("span", { className: s.value, children: e.email.value })
      ] }),
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Phone_Number") }),
        /* @__PURE__ */ t("span", { className: s.value, children: e.phoneNumber.value })
      ] }),
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Street") }),
        /* @__PURE__ */ t("span", { className: s.value, children: e.street.value })
      ] }),
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Zip_City") }),
        /* @__PURE__ */ c("span", { className: s.value, children: [
          e.zipCode.value,
          " ",
          e.city.value
        ] })
      ] }),
      /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_Country") }),
        /* @__PURE__ */ t("span", { className: s.value, children: e.country.selectedCountry.label })
      ] }),
      e.country.selectedCountry.selectedState && /* @__PURE__ */ c("div", { className: s.row, children: [
        /* @__PURE__ */ t("span", { className: s.label, children: r("Checkout_State") }),
        /* @__PURE__ */ t("span", { className: s.value, children: e.country.selectedCountry.selectedState.label })
      ] })
    ] });
  }
), Ee = ge.extend({
  continueToShippingButtonVariants: M.shape.variants.optional(),
  editAdressButtonVariants: M.shape.variants.optional(),
  headingSettings: T.optional(),
  fieldSettings: a.object({
    street: G.omit({ street: !0 }).optional()
  }).optional()
}), lt = m(
  "CheckoutAdressForm",
  p(Ee, (e) => {
    var L, P;
    const [s, r] = F(!0), [o, l] = F(!1), [u, f] = F(!1), [n, v] = F(e.address), [d, N] = F(
      e.shippingAddress
    ), { execute: b } = Ne("subscribe"), S = h(), k = oe.styles();
    se(() => {
      const i = e.validateAddress({ address: n, shippingAddress: d });
      r(i !== !0);
    }, []);
    function J() {
      const i = e.validateAddress({ address: n, shippingAddress: d });
      if (i === !0) {
        e.onUpdate({ address: n, shippingAddress: d }), r(!1), u && b({ email: n.email.value, attributes: {} });
        return;
      }
      v(i.address), N(i.shippingAddress);
    }
    const K = (i, C) => {
      const y = typeof C == "string" ? C : C.target.value;
      if (i === "country") {
        const g = n.country.options.find(
          (x) => x.value === y
        );
        if (!g)
          return;
        v((x) => ({
          ...x,
          country: {
            ...x.country,
            selectedCountry: g
          }
        }));
      }
      v((g) => ({
        ...g,
        [i]: {
          ...g[i],
          value: y
        }
      })), o || j(i, C);
    }, j = (i, C) => {
      const y = typeof C == "string" ? C : C.target.value;
      N((g) => ({
        ...g,
        [i]: {
          ...g[i],
          value: y
        }
      }));
    }, q = (i, C) => {
      var g, x;
      const y = C[i];
      if (y && y.validationResult !== !0 && ((x = (g = y.validationResult) == null ? void 0 : g.messages) != null && x.length))
        return {
          text: S(y.validationResult.messages[0] ?? ""),
          // Maybe UI-component should have support for array of messages?
          type: "error"
        };
    }, Q = (i) => q(i, n), X = (i) => q(i, d);
    return /* @__PURE__ */ c("section", { className: k.wrapper, children: [
      /* @__PURE__ */ t(
        w,
        {
          className: k.headingWrapper,
          heading: S("Checkout_Address_Heading"),
          ...e.headingSettings
        }
      ),
      s ? /* @__PURE__ */ c(H, { children: [
        /* @__PURE__ */ c(
          B,
          {
            setAddressField: K,
            getHelperText: Q,
            children: [
              /* @__PURE__ */ t(ye, {}),
              n.country.selectedCountry.stateRequired && /* @__PURE__ */ t(U, { country: n.country }),
              /* @__PURE__ */ t(W, { firstName: n.firstName }),
              /* @__PURE__ */ t(I, { lastName: n.lastName }),
              /* @__PURE__ */ t(R, { email: n.email }),
              /* @__PURE__ */ t(
                D,
                {
                  street: n.street,
                  ...(L = e.fieldSettings) == null ? void 0 : L.street
                }
              ),
              /* @__PURE__ */ t(Z, { zipCode: n.zipCode }),
              /* @__PURE__ */ t(V, { city: n.city }),
              /* @__PURE__ */ t(O, { phoneNumber: n.phoneNumber })
            ]
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            checked: o,
            label: S("Checkout_Address_Different_Shipping"),
            className: k.standardCheckbox,
            onChange: () => l(!o)
          }
        ),
        o && /* @__PURE__ */ c(
          B,
          {
            setAddressField: j,
            getHelperText: X,
            children: [
              n.country.selectedCountry.stateRequired && /* @__PURE__ */ t(U, { country: n.country }),
              /* @__PURE__ */ t(W, { firstName: d.firstName }),
              /* @__PURE__ */ t(I, { lastName: d.lastName }),
              /* @__PURE__ */ t(R, { email: n.email }),
              /* @__PURE__ */ t(
                D,
                {
                  street: d.street,
                  ...(P = e.fieldSettings) == null ? void 0 : P.street
                }
              ),
              /* @__PURE__ */ t(Z, { zipCode: d.zipCode }),
              /* @__PURE__ */ t(V, { city: d.city }),
              /* @__PURE__ */ t(O, { phoneNumber: d.phoneNumber })
            ]
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            checked: u,
            label: S("Checkout_Address_Signup_Newsletter"),
            className: k.newsletterBox,
            onChange: () => f(!u)
          }
        ),
        /* @__PURE__ */ t(
          E,
          {
            onClick: J,
            as: "button",
            label: S("Checkout_Address_Continue"),
            variants: e.continueToShippingButtonVariants ?? { width: "full" }
          }
        ),
        /* @__PURE__ */ t(He, { className: k.termsAndCondition })
      ] }) : /* @__PURE__ */ c(H, { children: [
        /* @__PURE__ */ t(Me, { address: n }),
        /* @__PURE__ */ t(
          E,
          {
            onClick: () => r(!0),
            as: "button",
            label: S("Checkout_Address_Edit"),
            variants: e.editAdressButtonVariants ?? { width: "full" }
          }
        )
      ] })
    ] });
  })
), ze = a.object({
  variants: a.custom().optional()
}).and(a.custom()), it = m(
  "PaymentWrapper",
  p(ze, (e) => {
    const s = le.styles(e.variants);
    return /* @__PURE__ */ t("div", { className: s.base, children: e.children });
  })
), Be = a.custom().and(
  a.object({
    description: a.string().optional(),
    logo: a.union([a.string(), a.custom()]).optional(),
    variants: a.custom().optional(),
    icons: a.object({
      active: a.custom().optional()
    }).optional(),
    shippingBarometer: a.object({
      component: a.custom().optional(),
      config: ke.optional()
    }).optional()
  })
), ct = m(
  "ShippingMethodOption",
  p(
    Be,
    ({
      isSelected: e,
      methodKey: s,
      onChange: r,
      label: o,
      description: l,
      logo: u,
      price: f,
      loading: n,
      variants: v,
      icons: d,
      shippingBarometer: N
    }) => {
      const b = ie.styles(v), S = (d == null ? void 0 : d.active) || /* @__PURE__ */ t(Se, {});
      return /* @__PURE__ */ c(
        "button",
        {
          className: b.base,
          "data-is-active": e,
          "data-is-loading": n ? "true" : "false",
          disabled: n || e,
          onClick: () => r(s),
          children: [
            /* @__PURE__ */ t("div", { className: b.activeIcon, children: e && S }),
            u && /* @__PURE__ */ t("div", { className: b.logo, children: typeof u == "string" ? /* @__PURE__ */ t(
              fe,
              {
                displaySize: "48px",
                image: { src: u, alt: o }
              }
            ) : u }),
            /* @__PURE__ */ t("span", { className: b.label, children: o }),
            l && /* @__PURE__ */ t("div", { className: b.usps, children: l.split(`
`).map((k) => /* @__PURE__ */ t("span", { className: b.usp, children: k }, k)) }),
            /* @__PURE__ */ t("span", { className: b.price, children: f }),
            (N == null ? void 0 : N.component) && /* @__PURE__ */ t("div", { className: b.shippingBarometer, children: N.component })
          ]
        }
      );
    }
  )
), We = a.object({
  heading: T.optional(),
  children: a.custom(),
  variants: a.custom().optional()
}).and(a.custom()), dt = m(
  "ShippingMethods",
  p(We, (e) => {
    const s = ce.styles(e.variants);
    return /* @__PURE__ */ c("div", { className: s.base, children: [
      /* @__PURE__ */ t(w, { ...e.heading, className: s.headingWrapper }),
      e.children
    ] });
  })
), ut = () => /* @__PURE__ */ t("p", { children: "At least one shipping method must be configured." });
export {
  lt as AddressForm,
  Me as AddressSummary,
  ot as Checkout,
  xe as CheckoutDisclaimer,
  V as City,
  R as Email,
  W as FirstName,
  B as FormProvider,
  I as LastName,
  it as PaymentWrapper,
  O as PhoneNumber,
  ct as ShippingMethodOption,
  dt as ShippingMethods,
  ut as ShippingMethodsNotConfigured,
  U as State,
  D as Street,
  He as TermsAndConditions,
  Z as ZipCode,
  G as addressFormStreetSchema,
  Ee as checkoutAddressFormPropsSchema,
  Ae as checkoutDisclaimerSchema,
  _e as checkoutSchema,
  ze as paymentWrapperSchema,
  Be as shippingMethodSchema,
  A as useFormContext
};
//# sourceMappingURL=index.es.js.map
